import { getCurrentRecordingState } from "config/helpers/recordingStateSelector";
import useSpeechToText from "hooks/useSpeechToText";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const BrowserEventHandler = ({
  onBeforeUnload = new Function(),
  onUnload = new Function(),
}) => {
  const patientId = useSelector((state) => state.patientObj?.patientObj?.id);
  const encounterId = useSelector((state) => state.encounterObj?.encounter?.id);

  const { recording: isRecording, paused: isPaused } = useSelector((state) =>
    getCurrentRecordingState(state, patientId, encounterId)
  );
  const progress= useSelector(state=>state?.isLoading?.progress)
  const {controls}=useSpeechToText()
  useEffect(() => {
    if (isRecording||progress||isPaused) {
      const handleBeforeUnload = (event) => {
        if (typeof onBeforeUnload === "function") {
          const confirmationMessage = onBeforeUnload();
          if (confirmationMessage) {
            event.preventDefault();
            event.returnValue = confirmationMessage;
            if(isRecording){
              controls.pauseTranscription()
            }
          }
        }
      };

      const handleUnload = () => {
        if (typeof onUnload === "function") {
          onUnload();
        }
      };

      const handleNavigation = (event) => {
        const confirmationMessage = "Are you sure you want to leave this page?";
        if (typeof onBeforeUnload === "function") {
          const customConfirmationMessage = onBeforeUnload();
          if (customConfirmationMessage) {
            if (!window.confirm(customConfirmationMessage)) {
              event.preventDefault();
            }
          } else {
            if (!window.confirm(confirmationMessage)) {
              event.preventDefault();
            }
          }
        } else {
          if (!window.confirm(confirmationMessage)) {
            event.preventDefault();
          }
        }
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("unload", handleUnload);
      window.addEventListener("beforeunload", handleNavigation);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("unload", handleUnload);
        window.removeEventListener("beforeunload", handleNavigation);
      };
    }
  }, [onBeforeUnload, onUnload, isRecording,progress]);

  return null;
};

export default BrowserEventHandler;
